import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './assets/styles/theme';
import Layout from './components/common/Layout';
import AppRoutes from './routes/AppRoutes';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Layout>
                    <AppRoutes />
                </Layout>
            </Router>
        </ThemeProvider>
    );
}

export default App;